export default __webpack_public_path__ + "img/catIconDefault.ea78599d.svg";